var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-3",class:[_vm.data.class, _vm.data.link !== undefined ? 'cursor-pointer' : ''],on:{"click":_vm.goTo}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }